import { render } from "./UploadSvg.vue?vue&type=template&id=69e60064&bindings={}"
import script from "./UploadSvg.vue?vue&type=script&lang=ts"
export * from "./UploadSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script